// eslint-disable-next-line no-restricted-imports
import type { DeletedModel } from 'app/gamma/src/modules/sockets';
// eslint-disable-next-line no-restricted-imports
import { isDeletedModel } from 'app/gamma/src/modules/sockets';
// eslint-disable-next-line no-restricted-imports
import type {
  NotificationGroupResponse,
  NotificationResponse,
} from 'app/gamma/src/types/responses';
import { loadReactionsFromNotifications } from './loadReactionsFromNotifications';

export const applySocketNotificationToReactions = ({
  delta,
}: {
  delta: NotificationResponse | DeletedModel;
}) => {
  if (isDeletedModel(delta)) {
    return;
  } else if (delta && delta.data && delta.data.card && delta.data.card.id) {
    const notificationGroupsResponse: NotificationGroupResponse[] = [
      {
        card: delta.data.card,
        id: `Card:${delta.data.card.id}`,
        notifications: [delta],
      },
    ];

    loadReactionsFromNotifications(notificationGroupsResponse);
  } else {
    return;
  }
};
